import * as React from "react";
import { Box, Button, FormControl, FormHelperText, InputLabel, MenuItem, Select } from "../../components/mui";
import { FactCheckRoundedIcon, GetAppRoundedIcon } from "../../components/icons";

import PageLayout from "../../components/shared/PageLayout";
import PageHeader from "../../components/shared/PageHeader";
import { useToast } from "../../components/shared/ToastProvider";

import "../../styles/pages/monthlyHeadcount.css";

const YEAR_OPTIONS = [
  { value: "2025", label: "2025" },
  { value: "2024", label: "2024" },
  { value: "2023", label: "2023" }
];

const MONTH_OPTIONS = [
  { value: "01", label: "January" },
  { value: "02", label: "February" },
  { value: "03", label: "March" },
  { value: "04", label: "April" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "August" },
  { value: "09", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" }
];

const REPORT_TYPES = [
  { value: "headcount", label: "Headcount" },
  { value: "occupancy", label: "Occupancy" }
];

export default function MonthlyHeadcount({ onLogout, onNavigate }) {
  const { showToast } = useToast();

  const [filters, setFilters] = React.useState({
    year: "",
    month: "",
    reportType: ""
  });
  const [errors, setErrors] = React.useState({
    year: false,
    month: false,
    reportType: false
  });

  const handleFilterChange = (field) => (event) => {
    const value = event.target.value;
    setFilters((prev) => ({
      ...prev,
      [field]: value
    }));

    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: false }));
    }
  };

  const handleGenerate = () => {
    const newErrors = {
      year: filters.year === "",
      month: filters.month === "",
      reportType: filters.reportType === ""
    };

    setErrors(newErrors);

    if (newErrors.year || newErrors.month || newErrors.reportType) {
      showToast({
        message: "Please fill in all required fields",
        severity: "error"
      });
      return;
    }

    // Placeholder for future integration
    showToast({
      message: "Monthly headcount report generating",
      severity: "success"
    });
  };

  return (
    <PageLayout activeKey="monthly-headcount" onLogout={onLogout} onNavigate={onNavigate} className="page-content">
      <PageHeader
        icon={FactCheckRoundedIcon}
        title="Monthly Headcount"
        summary="Monitor headcount and occupancy per condo for any month."
      />

      <Box className="content-box monthly-headcount-container">
        <Box className="monthly-headcount-form">
          <FormControl size="small" required error={errors.year} className="monthly-headcount-field">
            <InputLabel>Year</InputLabel>
            <Select value={filters.year} label="Year" onChange={handleFilterChange("year")}>
              <MenuItem value="">
                Select year
              </MenuItem>
              {YEAR_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
            {errors.year && <FormHelperText>This field is required</FormHelperText>}
          </FormControl>

          <FormControl size="small" required error={errors.month} className="monthly-headcount-field">
            <InputLabel>Month</InputLabel>
            <Select value={filters.month} label="Month" onChange={handleFilterChange("month")}>
              <MenuItem value="">
                Select month
              </MenuItem>
              {MONTH_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
            {errors.month && <FormHelperText>This field is required</FormHelperText>}
          </FormControl>

          <FormControl size="small" required error={errors.reportType} className="monthly-headcount-field">
            <InputLabel>Condo Report Type</InputLabel>
            <Select
              value={filters.reportType}
              label="Condo Report Type"
              onChange={handleFilterChange("reportType")}
            >
              <MenuItem value="">
                Select type
              </MenuItem>
              {REPORT_TYPES.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
            {errors.reportType && <FormHelperText>This field is required</FormHelperText>}
          </FormControl>

          <Box className="monthly-headcount-actions">
            <Button variant="contained" startIcon={<GetAppRoundedIcon />} onClick={handleGenerate}>
              Generate
            </Button>
          </Box>
        </Box>
      </Box>
    </PageLayout>
  );
}
